import { Directive, ElementRef, HostListener, AfterViewInit, AfterViewChecked } from '@angular/core';

@Directive({
  selector: 'textarea[autosize]'
})
export class AutosizeTextboxDirective implements AfterViewInit, AfterViewChecked {
  constructor(private el: ElementRef<HTMLTextAreaElement>) {}

  ngAfterViewChecked(): void {
    this.resize();
  }

  @HostListener('input')
  onInput(): void {
    this.resize();
  }

  ngAfterViewInit(): void {
    this.resize();
  }

  private resize(): void {
    const textarea = this.el.nativeElement as HTMLTextAreaElement;
    textarea.style.height = 'auto';

    // Size constraints
    const minHeight = 92;
    const maxHeight = 184;

    // Clamped to [minHeight, maxHeight]
    const newHeight = Math.min(Math.max(textarea.scrollHeight, minHeight), maxHeight);

    textarea.style.height = `${newHeight}px`;
    textarea.style.overflowY = textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }
}
